<template>
    <div v-if="ruleForm">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px">
            <el-form-item label="历程年月" prop="date" required>
              <el-date-picker
                v-model="ruleForm.date"
                type="date"
                value-format="timestamp"
                style="width:240px"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="历程描述" prop="intro" required>
                <el-input type="textarea" v-model="ruleForm.intro"></el-input>
            </el-form-item>
            <el-form-item label="历程图片">
                <UploadImgs v-model="ruleForm.photo" prefix='comp/aptitude/brandlcs'></UploadImgs>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    import UploadImgs from '@/components/upload/UploadImgs.vue';
    export default {
        components:{
            UploadImgs
        },
        props: ['case','formRef'],
        data() {
            return {
                ruleForm: null,
                rules: {
                    date: [{ required: true, message: '请输入历程年月', trigger: 'blur' }],
                    intro: [{ required: true, message: '请输入历程描述', trigger: 'blur' }],
                    // bg: [{ required: true, message: '请输入项目背景', trigger: 'blur' }],
                    // intro: [{ required: true, message: '请输入项目描述', trigger: 'blur' }],
                    // photo: [{ required: true, message: '请输入商品价格', trigger: 'blur' }],
                    // url: [{ required: true, message: '请输入商品价格', trigger: 'blur' }],
                }
            }
        },
        watch: {
            
        },
        async created() {
            
        },
        mounted() {
            this.ruleForm = this.case;
            // Object.assign(this.ruleForm,this.item);
            // console.log("111",this.ruleForm);
            // console.log(this.item);
        },
        methods: {
            validForm() {
                return new Promise((resolve, reject) => {
                    this.$refs.ruleForm.validate((valid) => {
                        if (valid) {
                            resolve(true);
                        } else {
                            return reject();
                        }
                    });
                });
            }
        }
    }
</script>
<style scoped>

</style>